(function() {
  'use strict';

  var selectOptions = {
    bindings: {
      oldValue: '<',
      newValue: '&',
      options: '<',
      formName: '<',
      index: '<',
      ruleRequired: '<'
    },
    template: [
      '<div  data-ng-class="{ \'has-error\': $ctrl.formName.select_{{$ctrl.index}}.$error.required && $ctrl.formName.$submitted }">',
      '<select data-ng-model="$ctrl.myService" name="select_{{$ctrl.index}}" class="form-control" ng-change="$ctrl.update($ctrl.myService)" ng-model-options="{ getterSetter: true}" ng-options="sendService as sendService.nomeExibicao for sendService in $ctrl.options" ng-required="$ctrl.ruleRequired">',
      '<option value="" disabled="disable">Selecione uma opção</option>',
      '</select>',
      '</div>'
    ].join(''),
    controller: [function() {
      var $ctrl = this;

      $ctrl.$onInit = function() {
        $ctrl.myService = setService($ctrl.oldValue.codigoMandae);
      }

      function setService(oldValue) {
        return _.find($ctrl.options, function(prop) {
          return prop.servicoEnvio == oldValue;
        });
      }

      $ctrl.update = function(obj) {
        $ctrl.newValue({ shippingOptions: obj });
      }

    }]
  };

  angular
    .module('mandaeApp')
    .component('selectOptions', selectOptions);

}());
